import {Directive, EventEmitter, HostListener, Inject, OnInit, Output} from '@angular/core';
import {ClsUtil} from "../../util/cls-util";

@Directive({
    selector: '[paste-handler-neodata]',
    standalone: true
})
export class PasteHandlerNeodataDirective implements OnInit {

  @Output()
  public onDataProcessed = new EventEmitter<any>();

  public textArea: any;

  constructor() { }

  @HostListener('focusin', ['$event'])
  public focusIn(eventArgs: any) {
  }

  @HostListener('keydown', ['$event'])
  public ControlV(eventArgs: any) {
    const ctrl = eventArgs.ctrlKey;
    const key = eventArgs.keyCode;
    // Ctrl-V || Shift-Ins || Cmd-V
    if ((ctrl || eventArgs.metaKey) && key === 86 || eventArgs.shiftKey && key === 45) {
      this.textArea.focus();
    }
  }

  public ngOnInit(): void {
    const div = document.createElement('div');
    const divStyle = div.style;
    divStyle.position = 'fixed';
    document.body.appendChild(div);
    this.textArea = document.createElement('textarea');
    const style = this.textArea.style;
    style.opacity = '0';
    style.height = '0px';
    style.width = '0px';
    style.overflow = 'hidden';
    div.appendChild(this.textArea);

    this.textArea.addEventListener('paste', (eventArgs: any) => { this.onPaste(eventArgs); });
  }

  public onPaste(eventArgs: any) {
    let htmlData: any;
    const clData = 'clipboardData';
    let esTextHtml = true;

    // get clipboard data - from window.cliboardData for IE or from the original event's arguments.
    if (window[clData]) {
      window.event.returnValue = false;
      htmlData = window[clData].getData('text/html');
      if (ClsUtil.esNulo(htmlData)) {
        htmlData = window[clData].getData("text");
        esTextHtml = false;
      }
    } else {
      htmlData = eventArgs[clData].getData('text/html');
      if (ClsUtil.esNulo(htmlData)) {
        htmlData = eventArgs[clData].getData("text/plain");
        esTextHtml = false;
      }
    }
    if (esTextHtml) {
      htmlData = this.htmlDataToPlainText(htmlData);
    }
    // process the clipboard data
    const processedData = this.processData(htmlData);

    this.onDataProcessed.emit(processedData);
  }

  public htmlDataToPlainText(htmlString: string): string {
    // Expresión regular para extraer filas y celdas
    const rowsRegex = /<tr[^>]*>(.*?)<\/tr>/gs;
    // Extraemos las filas
    const rowsMatch = htmlString.match(rowsRegex);

    if (rowsMatch) {
      // Extract columns from each row
      const columnsRegex = /<td[^>]*>(.*?)<\/td>/gs;
      const data = rowsMatch.map(row => {
        const columnsMatch = row.match(columnsRegex);
        if (columnsMatch) {
          // Limpiamos y procesamos los valores de las celdas
          const cleanedData = columnsMatch.map(val => {
            return this.cleanHtml(val);
          });
          return cleanedData.join('\t'); // Unimos los valores con tabuladores
        }

        return '';
      });

      return data.join('\n'); // Unimos las filas con saltos de línea);
    }
  }

  private cleanHtml(value: string): string {
    return value
      .replace(/<\/?[^>]+(>|$)/g, '') // Eliminar etiquetas HTML
      .replace(/[\r\n]/g, '') // Eliminar caracteres de nueva línea
      .replace(/&quot;/g, '"') // Reemplazar &quot; con "
      .replace(/&nbsp;/g, '') // Eliminar &nbsp;
      .replace(/\s+/g, ' ') // Eliminar espacios en blanco adicionales
      .trim(); // Eliminar espacios al inicio y al final
  }

  public processData(data: any) {
    const pasteData = data.split('\n');
    for (let i = 0; i < pasteData.length; i++) {
      pasteData[i] = pasteData[i].split('\t');
      // Check if last row is a dummy row
      if (pasteData[pasteData.length - 1].length === 1 && pasteData[pasteData.length - 1][0] === '') {
        pasteData.pop();
      }
      // remove empty data
      if (pasteData.length === 1 && pasteData[0].length === 1 && (pasteData[0][0] === '' || pasteData[0][0] === '\r')) {
        pasteData.pop();
      }
    }
    return pasteData;
  }
}

